import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseDatatable";

import { getAllMonthlyRedux } from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import "./lot-transport.css";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllMonthlyRedux("TRANSPORT");
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="monthly-expense" parent="expense-history" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid lt-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card lt-card">
                <div className="card-header lt-card-header">
                  <h5 className="lt-card-title">
                    <i className="icofont-list lt-card-icon"></i>
                    TRANSPORT
                  </h5>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.props.allMonths}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allMonths: state.expenses.monthly,
  };
};

export default connect(mapStateToProps, {
  getAllMonthlyRedux,
})(MonthlyExpense);
